export default {
  rows: state => state.rows,
  pagination: state => state.pagination,
  filter: state => state.filter,
  isOpenFilter: state => state.isOpenFilter,
};
